module.exports = new Promise(async (resolve, reject) => {
      try {
        const module = await import('https://sn2-whiteboard-dev10.web.app/assets/remoteEntry.js?t=1751427682983');
        resolve(module);
      } catch (error) {
        // console.error('Failed to load remote:', error);
        resolve(null);
      }
    })
;